import { useEffect } from 'react'
import { Bookmark, Package, Settings2, SlidersHorizontal } from 'lucide-react'

export type MenuKey = 'setup' | 'pantry' | 'saved' | 'settings'

const ROWS: Array<{ key: MenuKey; label: string; Icon: typeof Package }> = [
  { key: 'setup', label: 'Your setup', Icon: SlidersHorizontal },
  { key: 'pantry', label: "What's in the house", Icon: Package },
  { key: 'saved', label: 'Saved', Icon: Bookmark },
  { key: 'settings', label: 'Settings', Icon: Settings2 },
]

export function MenuSheet({ notes, onPick, onClose }: {
  notes: Record<MenuKey, string>
  onPick: (key: MenuKey) => void
  onClose: () => void
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="menu-sheet" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Menu">
        <div className="grab" />
        {ROWS.map(({ key, label, Icon }) => (
          <button key={key} className="menu-row" onClick={() => onPick(key)}>
            <span className="mi"><Icon size={20} strokeWidth={2.6} /></span>
            <span className="ml">{label}</span>
            <span className="mn">{notes[key]}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
